"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphSchema = void 0;
exports.ParagraphSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/paragraph.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Paragraph",
    "description": "A paragraph stores text-block, other embedded content resources (such as videos, image-galleries, etc.) or services",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:paragraph"
            ]
        },
        "anchor": {
            "description": "Navigational anchor, facilitating direct access to specific paragraph.",
            "$ref": "https://www.redbull.com/schemas/attributes/anchor.schema.json"
        },
        "emphasize": {
            "type": "boolean",
            "description": "Indicates whether a paragraph should be emphasized"
        },
        "contents": {
            "type": "array",
            "items": {
                "anyOf": [
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/enumeration.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/accordion.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/info-snippet.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/info-block.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/info-block-group.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/legal-disclaimer.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/question-and-answers.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/quote.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/related-content-container.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/results-table.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/table.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/call-to-action.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/audio-clips.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/audio-episodes.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/energy-drinks.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/episode-videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/externals.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/films.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/image-galleries.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/judges.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/live-videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/platform-extension/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/photographers.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/project-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/rally-drivers.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/rally-teams.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/recap-videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/results-standings.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/stories.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/team-profiles.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/trailer-videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/tv-commercials.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/videos-360.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/acast-audio/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/brackets-embed/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/facebook-socialembed-post/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/facebook-sociallink/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/giphy-videoclip/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/instagram-embed/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/instagram-sociallink/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/jotform-forms/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/mixcloud-audio/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/participant-gallery/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/pixlee-embed/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/rally-tv-video/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-live/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-video/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/riddle-embed/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/riddle-embed/2.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-livevideo/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-video/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/snapchat-sociallink/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/2.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/2.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/thing-link/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/tickaroo-embed/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/tiktok-embed/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/2.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/twitter-socialembed/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/twitter-sociallink/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/vimeo-video/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/vk-video/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/wrc-erc-standings-and-results/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-playlist/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-short/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-video/1.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/content/ext/services/zoe-embed/1.schema.json"
                    }
                ]
            }
        },
        "title": {
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        },
        "meta": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "preferredStyling": {
                    "type": "string"
                }
            }
        }
    },
    "required": [
        "contents",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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